module.exports = __webpack_public_path__ + "static/img/anxun21new1.07c3f97a.png";